import { connect } from "react-redux";
 
import SplashScreen from "./SplashScreen";
 
import { getGameCodeList, getInfo } from "services";
import { updateToken } from "store/auth";
 
 
const mapDispatchToProps = dispatch => ({
  updateToken: token => dispatch(updateToken(token)),
  getGameCodeList: params => dispatch(getGameCodeList(params)),
  getInfo: params => dispatch(getInfo(params))
 
});
 
export default connect(null, mapDispatchToProps)(SplashScreen);
 